export function parseNumber(value: string): number | null {
  if (value === null) { return null; }
  const number = Number(value);
  return isNaN(number) ? null : number;
}
